<template>
	<section class="promotions-wrapper">
		<div class="background-overlay"></div>
		<div class="row">
			<section class="promotions columns">
				<div v-for="block in items.slice(0, amount)" :key="block.ID" class="promoblock">
					<div class="content">
						<h2>{{ block.header }}</h2>
						<div v-parse-links v-html="block.content" />
					</div>

					<picture>
						<source v-if="block.imageWebp" :srcset="block.image" type="image/webp" />
						<source :srcset="block.image" />
						<img :src="block.image" :alt="block.imageAlt" class="promo-img" loading="lazy" />
					</picture>
				</div>
			</section>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.promotions-wrapper {
	position: relative;
	padding-bottom: 50px;
	margin-bottom: -1px;

	.columns {
		padding: 0 !important;
	}

	.background-overlay {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 50%;
		background: #05462e;
		z-index: 0;
	}

	.second-background-overlay {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 50%;
		background: #05462e;
		z-index: 0;
	}

	.promotions {
		margin: 0 auto;
		text-align: center;
		display: flex;
		flex-flow: row wrap;
		position: relative;

		.promoblock {
			flex-basis: calc(100% / 3);
			text-decoration: none;
			border-radius: 6px;
			margin: 0 auto;
			padding: 15px;
			display: inline-block;
			position: relative;

			.content {
				position: absolute;
				top: 50%;
				left: 10px;
				right: 10px;
				margin-top: -55px;
				text-align: center;
				color: #fff;
				z-index: 2;

				h2,
				h3,
				h2 a,
				h3 a {
					color: #fff;
					margin: 0 0 30px;
				}

				h2 {
					text-transform: uppercase;
				}
			}

			.promo-img {
				opacity: 1;
				width: 100%;
				transition: all 0.3s ease-in-out;
			}

			&::before {
				content: '';
				position: absolute;
				inset: 15px;
				background-color: rgb(0 0 0 / 40%);
				opacity: 1;
				transition: opacity 0.3s ease-in-out;
				z-index: 1;
			}

			&:hover::before {
				opacity: 0.8;
			}

			&::after {
				content: '';
				position: absolute;
				inset: 45px;
				background-color: rgb(156 186 94 / 10%);
				border: 1px solid rgb(156 186 94 / 100%);
				pointer-events: none;
				transition: all 0.3s ease;
			}

			&:hover::after {
				background-color: rgb(156 186 94 / 70%);
				inset: 35px;
				border-color: rgb(156 186 94 / 10%);
			}
		}
	}
}

@media (max-width: 850px) {
	.row {
		padding: 5px;
	}

	.background-overlay {
		height: 80% !important;
	}

	.promoblock {
		flex-basis: 100% !important;
	}
}

@media (max-width: 580px) {
	.promotions-wrapper {
		.promotions {
			.promoblock {
				&::before {
					opacity: 0.8;
				}

				&::after {
					background-color: rgb(156 186 94 / 70%);
					inset: 35px;
					border-color: rgb(156 186 94 / 10%);
				}
			}
		}
	}
}
</style>
